const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

/** "2026-10-01" to "1 Oct 2026", the same on the server and in the browser. */
export const formatPostDate = (value: string): string => {
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})/)

    if (!match) return value

    return `${Number(match[3])} ${MONTHS[Number(match[2]) - 1]} ${match[1]}`
}
